import React, { useContext } from 'react'
import { Context } from '../../../../context/app-context'
import Button from '../../../atoms/button/button'
import { pushEventData } from '../../../../utils/pushEventDataLayer'
import { jsonToHash } from '../../../../utils/crypto'
import userSessionStorage from '../../../../utils/userSessionStorage'
import { navigate } from 'gatsby'
import { rewardsTextByLocale, PremiosByLocale,   rewardsTabText } from './tab4.textbylocale'
import { WORDS } from '../../../../constants/keywords'

const getuserdata = async userInfo => {
  return {
    user_data: userInfo && [
      await jsonToHash({
        nombre: userInfo.name,
        apellido: userInfo.lastName,
        celular: userInfo.cellPhone,
        correo: userInfo.email,
        ciudad: userInfo.location.cityName,
        departamento: userInfo.location.countryStateName,
        pais: userInfo.countryName,
      }),
    ],
    log_status: userInfo ? 'Yes' : 'Not',
  }
}
const handlerGoToTerms = async (evt, userInfo, dispatch) => {
  if (evt) {
    let text = evt.target?.innerText
    if (text) {
      pushEventData({
        event: 'Interacciones_Enlaces',
        category: 'link',
        label: text,
        ...(await getuserdata(userInfo)),
      })
    }
  }
  dispatch({
    type: 'set-modal',
    modalActive: {
      type: 'terms',
      wrapperProps: {
        className: 'f-modalTerms',
        blur: true,
      },
    },
  })
}
const handlerGoToGame = async userInfo => {
  pushEventData({
    event: 'Interacciones_Home_RompeTabus',
    category: 'Juega',
    action: 'click',
    label: 'Haz clic aca',
    ...(await getuserdata(userInfo)),
  })
  navigate('/game')
}

const Tab4 = ({ isMobile }) => {
  const { dispatch } = useContext(Context)
  const session = new userSessionStorage()
  const userInfo = session.getUserInfo()
  return (
    <>
      {isMobile && <h3>Gana</h3>}
      <div className="tab-content__imgTab2">{PremiosByLocale()}</div>
      <div className="tab-content__info">
        <p className="tab-content__text">
          {rewardsTextByLocale()}
          <br />
          {rewardsTabText()}
          <span className="--pink">
            <a
              className="f-containerTerminos__aTerminos"
              onClick={evt => {
                handlerGoToTerms(evt, userInfo, dispatch)
              }}
            >
              {WORDS.aqui}
            </a>
          </span>
          <br />
          <br />
          Ahora sí, <span>¡sé la mejor derribando tabús!</span>
        </p>
        <Button onClick={() => handlerGoToGame(userInfo)} className="--btnTabs">
          ¡Ya quiero jugar!
        </Button>
      </div>
    </>
  )
}

export default Tab4
